import { useTranslation } from "react-i18next";
import { Button, Text } from "../common";
import {
  Body,
  Container,
  Footer,
  TextShadow
} from "./index.styled";


const TriggeredPaywall: React.FC<{ handleClose: () => void }> = ({ handleClose }) => {
  const { t } = useTranslation("private-home-page", { keyPrefix: "paywall.triggered" });

  return (
    <Container
      widthRem={26}
    >
        <Body height="12rem">
        <TextShadow
            as="p"
            fontSize={32}
            fontWeight={700}
            color={"#7F28B5"}
            maxWidth={330}
            lineHeight={30}
            margin="2rem 0"
            shadow="0px 0px 20px rgba(127, 40, 181, 0.2)"
          >
            {t("title")}
          </TextShadow>
          <Text
            as="p"
            fontSize={16}
            fontWeight={400}
            color={"#595959"}
            margin="2rem auto"
            align="start"
          >
            {t("desc-1")}
          </Text>
        </Body>
        <Footer>
          <Button
            backgroundColor="#049EFB"
            textColor="#fff"
            onClick={() => {
              handleClose();
            }}
            width="100%"
            margin="0"
            fontSize={14}
            fontWeight={700}
            padding="0.75rem 1rem"
          >
            {t("continue-button")}
          </Button>
        </Footer>
      </Container>
  )
};

export default TriggeredPaywall;
